<template>

    <div class="modal attendance-modal fade" id="newConversationFromOfferModal" tabindex="-1" aria-labelledby="newConversationFromOfferModal" aria-hidden="true" style="z-index:99999;">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                    <div>
                        <p class="text-lg mb-0 fw-semibold">Nieuw gesprek starten</p>
                    </div>
                    <button @click="hideModal()" type="button" class="btn-close mb-0 me-0"></button>
                </div>

                <div class="modal-body pt-3 px-4 pb-3">

                    <!-- First Message -->
                    <div class="my-3">
                        <label class="form-label fw-semibold">Eerste bericht</label>
                        <textarea
                            class="form-control conversation-message-input"
                            v-model="firstMessage"
                            rows="14"
                            placeholder="Schrijf hier je eerste bericht..."
                        ></textarea>
                    </div>

                    <!-- Users Selection -->
                    <div class="mb-0">
                        <label class="form-label fw-semibold">Gebruikers toevoegen</label>
                        <div class="employees-list" v-if="users.length > 0">
                            <label class="employee" v-for="user in users" :for="'user-' + user.id" role="button">
                                <div class="message-content">
                                    <div class="name text-sm fw-semibold">
                                        <input
                                            v-model="user.is_linked"
                                            type="checkbox"
                                            :id="'user-' + user.id"
                                            :disabled="user.id === currentUserId">
                                        <div>
                                            {{ user.name }}
                                        </div>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="modal-body pt-0 px-4 pb-4 d-flex">
                    <button
                        class="btn btn-primary ms-auto px-3 py-2 text-sm"
                        @click="createConversation()"
                        :disabled="!canCreateConversation"
                    >
                        Gesprek starten
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {EventBus} from "../../../event-bus";

export default {
    name: 'new-conversation-from-offer-modal',
    data() {
        return {
            orderId: '',
            firstMessage: '',
            users: [],
            currentUserId: null,
            redirectUrl: '',
            type: '',
            loading: false
        }
    },
    computed: {
        canCreateConversation() {
            // Check if a message is entered
            return this.firstMessage.trim() !== '';
        }
    },
    methods: {
        ensureCurrentUserIsLinked() {
            const currentUser = this.users.find(user => user.id === this.currentUserId);
            if (currentUser) {
                currentUser.is_linked = true;
            }
        },
        createConversation() {
            if (!this.canCreateConversation) {
                return;
            }

            this.ensureCurrentUserIsLinked();

            const selectedUsers = this.users.filter(user => user.is_linked);

            axios.post('api/add-new-conversation', {
                orderId: this.orderId,
                type: this.type,
                message: this.firstMessage,
                users: selectedUsers
            })
            .then(response => {
                if (response.data.status === 422) {
                    this.modal.hide();
                    throw [true, response.data.message];
                }

                 this.hideModal();
            })
            .catch(e => {
                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het aanmaken van het gesprek.", "error");
            });
        },
        loadUsers() {
            axios.get('api/get-all-users')
            .then(response => {
                if (response.data.status === 422) {
                    throw [true, response.data.message];
                }

                this.users = response.data.users;
                this.currentUserId = response.data.currentUserId;
            })
            .catch(e => {
                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van gebruikers.", "error");
            });
        },
        hideModal() {
            window.location.href = this.redirectUrl;
        },
    },
    mounted() {
        this.modal = new bootstrap.Modal(document.getElementById('newConversationFromOfferModal'));

        EventBus.$on('openNewConversationFromOfferModal', (data) => {
            this.redirectUrl = data.redirectUrl;
            this.orderId = data.orderId;
            this.type = data.type;

            this.loadUsers();
            this.modal.show();
        });
    }
}
</script>
